// extracted by mini-css-extract-plugin
export default {"root":"MainLayouts_root__abo90","endUserRoot":"MainLayouts_endUserRoot__UtjZ3"};